export default "__VITE_ASSET__6f4594e4__"